<div class="flex-column">
  @if (!disableVoucherEditing && !orderComplete) {
    <form class="basket-charge-input-group" style="position: relative;">

      <input id="voucherInput"
            [formControl]="inputFormControl"
            class="voucher-input"
            [class.disabled]="errorMessage"
            [style.opacity]="isVoucherSaving ? '0.4' : '1'"
            placeholder="Enter it here."
            autocomplete="off"
            (keydown.enter)="$event.preventDefault(); applyVoucher()"/>

        @if (isVoucherSaving) {
          <div class="spinner-container">
            <div class="lds-dual-ring"></div>
          </div>
        }

        <button class="voucher-btn"
          type="button"
          mat-stroked-button
          (click)="applyVoucher()"
          [disabled]="inputFormControl.invalid || isVoucherSaving">
          Apply
        </button>
      </form>
    }

    <span class="basket-charge-alert red-alert-text" style="font-size: 13px;">{{ errorMessage }}</span>
  </div>

  <ng-template #DealsModal>
    <app-deals [deal]="deal" [occasion]="basket.Occasion" group="basket-voucher" (close)="closeDealModal()"></app-deals>
  </ng-template>
